import React from "react";
import config from "../../../config"
import _ from "underscore"
import { setRecentSearch } from "../helpers"

const SearchTerms = React.memo(({searchTerms, searchQuery}) => {
  return (
    <div className="search-menu__trending-list">
      {_.map(searchTerms.slice(0, 8), (searchTerm, idx) => {
        return (
          <SearchTerm key={idx} searchTerm={searchTerm} searchQuery={searchQuery}/>
        )
      })}
    </div>
  )
})

const SearchTerm = React.memo(({searchTerm, searchQuery}) => {

  const handleOnClick = (evt) => {
    evt.preventDefault();
    if (searchQuery) setRecentSearch(searchQuery);
    window.location.href = `${config.host_rebag_shop}${searchTerm.search_url}`
  }

  return (
    <a href={`${config.host_rebag_shop}${searchTerm.search_url}`} title={searchTerm.title} className="search-menu__trending-item" onClick={(evt) => handleOnClick(evt)}>
      {searchTerm.title}
    </a>
  )
})

export default SearchTerms;